var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PROFILE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.13,51.31h20a1.75,1.75,0,0,0,1.75-1.75V44.44a11.067,11.067,0,0,0-4.4-8.832,9.977,9.977,0,1,0-14.713,0A11.08,11.08,0,0,0,28.38,44.44v5.12A1.75,1.75,0,0,0,30.13,51.31Zm10-28.894a6.477,6.477,0,1,1-6.477,6.477A6.485,6.485,0,0,1,40.126,22.417ZM31.88,44.44a7.576,7.576,0,0,1,3.87-6.594,9.857,9.857,0,0,0,8.754,0A7.56,7.56,0,0,1,48.38,44.44v3.37H31.88Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.654,4.75H15.346A1.75,1.75,0,0,0,13.6,6.5v115a1.75,1.75,0,0,0,1.75,1.75h97.308a1.75,1.75,0,0,0,1.75-1.75V6.5A1.75,1.75,0,0,0,112.654,4.75Zm-1.75,115H17.1V8.25H110.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.346,65.75h75.308a1.75,1.75,0,1,0,0-3.5H26.346a1.75,1.75,0,0,0,0,3.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.346,80.194h75.308a1.75,1.75,0,0,0,0-3.5H26.346a1.75,1.75,0,0,0,0,3.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.346,109.083h75.308a1.75,1.75,0,0,0,0-3.5H26.346a1.75,1.75,0,0,0,0,3.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.346,94.639h75.308a1.75,1.75,0,1,0,0-3.5H26.346a1.75,1.75,0,0,0,0,3.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64,22.417h37.654a1.75,1.75,0,0,0,0-3.5H64a1.75,1.75,0,0,0,0,3.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64,36.861h37.654a1.75,1.75,0,0,0,0-3.5H64a1.75,1.75,0,0,0,0,3.5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64,51.306h37.654a1.75,1.75,0,0,0,0-3.5H64a1.75,1.75,0,0,0,0,3.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResume);
export default __webpack_public_path__ + "static/media/resume.82beb2bfccebd61631e892a55432925b.svg";
export { ForwardRef as ReactComponent };